import { useModal } from '@europrocurement/flexy-components';
import { Catalogs, useOffreService } from '@europrocurement/l2d-domain';
import { AnyAction } from '@reduxjs/toolkit';
import React from 'react';
import { useDispatch } from 'react-redux';
import {
    CatalogueCatalogueRead,
    PackagePackageRead,
} from '@europrocurement/l2d-domain/openApi/ApiOffre';
import { Menu, MenuItem } from '@mui/material';
import FormCatalogue from '../../../Offres/Catalog/Form/Form';
import FormPackage from '../../../Offres/Package/Form/Form';
import { PrescriberArticleOverrideForm } from '../../../Offres/Prescriber';

const ActionMenuItems: React.FunctionComponent<{
    showPrescripteur: boolean;
    showCatalogue: boolean;
    showPackage: boolean;
    catalogue: Catalogs | null;
    open: boolean;
    idPrescriber?: number;
    close: () => void;
    anchorEl: HTMLElement | null;
}> = function ({
    showPrescripteur = false,
    showCatalogue = false,
    showPackage = false,
    idPrescriber = undefined,
    catalogue = null,
    open = false,
    close = null,
    anchorEl = null,
}) {
    const dispatch = useDispatch();
    const { getCatalogs } = useOffreService();
    const { modalActions } = useModal();

    const reloadList = () => {
        setTimeout(() => {
            dispatch(getCatalogs({}) as unknown as AnyAction);
            modalActions.close();
        }, 2000);
    };

    const handleClose = () => {
        if (close) {
            close();
        }
    };
    const handlePrescriber = () => {
        if (!catalogue || !catalogue.id) {
            throw new Error('missing catalogue');
        }
        modalActions.call(
            <PrescriberArticleOverrideForm
                entity={catalogue}
                idCatalogue={catalogue.id}
                isCreate={false}
                afterSubmit={reloadList}
                idPrescriber={idPrescriber}
            />,
        );
    };

    const handleCatalogue = () =>
        modalActions.call(
            <FormCatalogue
                entity={catalogue as CatalogueCatalogueRead}
                isCreate={false}
                afterSubmit={reloadList}
            />,
        );

    const handlePackage = () =>
        modalActions.call(
            <FormPackage
                entity={catalogue?.package as PackagePackageRead}
                isCreate={false}
                afterSubmit={reloadList}
            />,
        );

    return (
        <Menu
            id={`${catalogue?.id}-catalogue-long-menu`}
            MenuListProps={{
                'aria-labelledby': 'long-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
        >
            {showPrescripteur ? (
                <MenuItem
                    key={`${catalogue?.id}-catalogue-prescripteur`}
                    onClick={handlePrescriber}
                >
                    Surcharge Prescripteur
                </MenuItem>
            ) : null}
            {showCatalogue ? (
                <MenuItem
                    key={`${catalogue?.id}-catalogue-catalogue`}
                    onClick={handleCatalogue}
                >
                    Surcharge Catalogue
                </MenuItem>
            ) : null}
            {showPackage ? (
                <MenuItem
                    key={`${catalogue?.id}-catalogue-package`}
                    onClick={handlePackage}
                >
                    Surcharge Package
                </MenuItem>
            ) : null}
        </Menu>
    );
};
export default ActionMenuItems;
